/*
 *  Copyright (c) Qwoach LLC 2021. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 5/11/2021
 */
import {
	query,
	collectionGroup,
} from "firebase/firestore"

import CollectionRef from "@/core/js/backend/FIrebaseWrappers/ref/CollectionRef";

export default class CollectionGroupRef extends CollectionRef{

	constructor(firestore, ...paths) {
		super(firestore, ...paths)
	}

	_buildQuery(){
		let queryConstraintsExecuted = this.getQueryConstraintsExecuted()
		console.log("CollectionGroupRef._buildQuery = ", this.queryConstraints, ", this.paths = ", this.paths, ", queryConstraintsExecuted = ", queryConstraintsExecuted)
		return query(collectionGroup(this.firestore, ...this.paths), ...queryConstraintsExecuted)
	}

}
